module.exports = __webpack_public_path__ + "static/media/BICI_B.9b70a6b6.svg";